import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M2 12h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 4v16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m3 9 3 3-3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 6 9 9 6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 18 3-3 1.5 1.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "ThermometerSnowflake";
const ThermometerSnowflake = memo(themed(Icon));
export {
  ThermometerSnowflake
};
//# sourceMappingURL=thermometer-snowflake.js.map
